import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { requestSignOut } from '@/store/actions/authenticate';
import Button from '@/components/common/button';

const SignOut = () => {
  const dispatch = useDispatch();
  const [signOutUrl, setSignOutUrl] = useState(null);

  useEffect(() => {
    if (signOutUrl) {
      window.location.href = signOutUrl;
    }
  }, [signOutUrl]);

  const onClickLogout = () => {
    dispatch(
      requestSignOut((val) => {
        setSignOutUrl(val);
      }),
    );
  };

  return (
    <div className="sign-out-action">
      <Button type="ghost" size="large" block onClick={onClickLogout}>
        Sign Out
      </Button>
    </div>
  );
};
export default SignOut;
